import { Box, Typography } from '@mui/material';
import React from 'react';
import CardMachine from './CardMachine';
import CardSkeleton from './CardSkeleton';
import useDataMachines from '../../hooks/useDataMahines';
import { useService } from '../../store/service.store';
import { useTour } from '../../provider/TourGuide';
import NewPreloader from '../Common/NewPreloader';

const List = () => {
    const { data, isLoading } = useDataMachines();
    const { search } = useService();
    const { enableService } = useTour()
    const filteredData = data?.filter((item) => {
        const searchTrimmed = search?.toLowerCase().trim() || '';
        const sku = item.product.sku?.toLowerCase() || '';
        const title = item.product.title?.toLowerCase() || '';
        const serialNumber = item.product.serialNumber?.toLowerCase() || '';
        return (
            sku.includes(searchTrimmed) ||
            title.includes(searchTrimmed) ||
            serialNumber.includes(searchTrimmed)
        );
    });

    return (
        <Box>
            <Box sx={{ padding: '10px' }}  id={"service1"}>
                <Typography variant="h5" color="#154D72" fontWeight={700} lineHeight="28px" fontSize="20px">
                    המכונות שלי
                </Typography>
                {filteredData && filteredData.length > 0 && (
                    <Typography variant="body2" color="#436F7C" fontSize="13px" fontWeight={400}>
                        לפתיחת קריאת שירות, לחצו על המכונה
                    </Typography>
                )}
            </Box>
            <Box id={"service2"}>
            {enableService ?
                <CardMachine
                    item={{
                        // @ts-ignore
                        product: {
                        id: 42,
                        sku: "COF-M00002-PAS",
                        title: "מכונת קפה Pascale Roma 1GR",
                        description: "",
                        packQuantity: 0,
                        price: 0,
                        type: "product",
                        brand: { title: "" },
                        category: {
                            type: "machine",
                            isPublished: true,
                            title: "גרניטה"
                        },
                        image: {
                            source: "product",
                            filePath: "media/product/product_COF-M00002-PAS.png",
                            contentUrl: ""
                        },
                        serialNumber: "3297",
                        inPack: "0",
                        isEditable: false,
                    
                        itboType: "",
                        itboConvglas: "",
                        published: false,
                        kosher: false,
                        pdf: "",
                        videoLink: "",
                        tagGroups: [],
                        unitQuantity: "0",           
                        packName: "",               
                        packName2: "",              
                        packUnit: "",               
                        },
                        services: []
                    }}
                />
            : null
            }
            </Box>

            {isLoading ? (
                <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', mt:'100px'}}>
                    <NewPreloader/>
                </Box>
                // [...Array(5)].map((_, index) => <CardSkeleton key={index} />)
            ) : (
                filteredData?.map((item) => <CardMachine key={item.product.id} item={item} />)
            )}
        </Box>
    );
};

export default List;
